module.exports = __webpack_public_path__ + "static/assets/a45329a2542b590a54dba0ccd30fdf4e.gif";